module.exports = __webpack_public_path__ + "static/media/youtube.1e21e122.png";